import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { researchPrograms } from "@/mocks/homeData";

export default function ResearchSection() {
  return (
    <section className="bg-white py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Header */}
        <ScrollReveal>
          <div className="max-w-3xl mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-6">
              <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                / Research Wing
              </span>
            </div>
            <h2 className="font-serif text-2xl md:text-3xl lg:text-5xl font-bold text-tie-text-primary leading-tight">
              Applied Research That Solves Real Factory Problems
            </h2>
            <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary">
              PIARC, IJTAI, and AIRCon form TIE's research backbone - bridging
              academic knowledge with factory floor reality.
            </p>
          </div>
        </ScrollReveal>

        {/* Research Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {researchPrograms.map((prog, index) => (
            <ScrollReveal key={prog.name} delay={index * 150}>
              <div className="group h-full bg-tie-grey-light rounded-2xl overflow-hidden border border-tie-grey-dark hover:border-tie-teal/30 hover:shadow-xl transition-all duration-300">
                {/* Image Area */}
                <div className="relative h-48 md:h-56 overflow-hidden">
                  <img
                    src={[
                      "https://readdy.ai/api/search-image?query=Modern%20textile%20research%20laboratory%20with%20scientists%20analyzing%20fabric%20samples%20under%20microscopes%2C%20clean%20white%20lab%20environment%20with%20advanced%20equipment%2C%20warm%20professional%20lighting%2C%20premium%20corporate%20research%20facility%20aesthetic%2C%20teal%20accent%20lighting&width=600&height=400&seq=3&orientation=landscape",
                      "https://readdy.ai/api/search-image?query=Professional%20research%20journal%20publication%20editorial%20office%20with%20printed%20textile%20research%20papers%2C%20academic%20setting%2C%20warm%20lighting%2C%20modern%20workspace%20with%20books%20and%20documents%2C%20premium%20corporate%20aesthetic&width=600&height=400&seq=4&orientation=landscape",
                      "https://readdy.ai/api/search-image?query=International%20research%20conference%20stage%20with%20podium%20and%20large%20screen%2C%20professional%20audience%20seating%2C%20modern%20conference%20hall%20lighting%2C%20teal%20and%20navy%20color%20scheme%2C%20corporate%20event%20photography&width=600&height=400&seq=5&orientation=landscape",
                    ][index]}
                    alt={prog.fullName}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-tie-navy/50 to-transparent" />
                  <div className="absolute bottom-4 left-4">
                    <span className="text-xs font-bold text-white uppercase tracking-wider">
                      {prog.name}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-5 md:p-6">
                  <h3 className="text-base md:text-lg font-semibold text-tie-text-primary mb-2">
                    {prog.fullName}
                  </h3>
                  <p className="text-sm text-tie-text-secondary leading-relaxed mb-4">
                    {prog.description}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {prog.areas.map((area) => (
                      <span
                        key={area}
                        className="px-2.5 py-1 rounded-full bg-tie-teal/10 text-xs text-tie-teal font-medium"
                      >
                        {area}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}